import {
  apiGatewayAPI,
  mrAPIV3,
  fakeAPI,
  strapiAPI,
  axiosUserDataAPI,
  axiosPortalInstance,
} from './axios';
import { MarketDataAPI } from './core';
import { MicroservicesAPI } from './microservices';
import { PortalAPI } from './portal';
import { UserDataAPI } from './userdata';

// API Gateway
export const marketDataGateway = new MarketDataAPI(apiGatewayAPI);
export const marketDataApi = new MarketDataAPI(apiGatewayAPI)
  .setDomain('mr-data')
  .setVersion('v4');

export const microservicesApi = new MicroservicesAPI(apiGatewayAPI)
  .setDomain('ms')
  .setVersion('v2');

// Data API (antiga API de dados)
export const marketData = new MarketDataAPI(mrAPIV3);
export const marketDataV4 = new MarketDataAPI(mrAPIV3).setVersion('v4');

// Strapi
export const strapiMarketData = new MarketDataAPI(strapiAPI);
export const portal = new PortalAPI(axiosPortalInstance);

// User Data
export const userData = new MarketDataAPI(axiosUserDataAPI);
export const _userData = new UserDataAPI(axiosUserDataAPI);

export const fakeMarketData = new MarketDataAPI(fakeAPI);

export * from './interface';
export * from './interfaces/portfolio';
export * from './interfaces/comparison';
export * from './interfaces/funds';
export * from './interfaces/props';
export * from './interfaces/general';
export * from './interfaces/userdata';
export * from './interfaces/team';
export * from './interfaces/portal';
export * from './interfaces/sheet';
export * from './interfaces/windows';
export * from './axios';
export * from './core';
export * from './userdata'
